import { useState } from 'react';
import styles from './style.module.css';
import { ToggleButton } from './toggleButton';
import { CaretIcon, MenuIcon, MenuIcon2 } from '../../../assets';
import { CategoryList } from '../../../lib/constants';
import Typography from '../../../components/Typography/Typography';
import { useNavigate } from 'react-router';

export const Categories = () => {
  // const [selectedButton, setSelectedButton] = useState<string | null>(null);
  // const [selectedCategory, setSelectedCategory] = useState("")
  const [showCategory, setShowCategory] = useState(false)

  const navigate = useNavigate()

  // const handleButtonClick = (name: string) => {
  //   setSelectedButton(selectedButton === name ? null : name);
  // };

  const data = [
    { category: "Electronics", amount: 1200 },
    { category: "Clothing", amount: 950 },
    { category: "Home & Kitchen", amount: 780 },
    { category: "Sports", amount: 640 },
    { category: "Beauty & Health", amount: 520 },
    { category: "Toys & Games", amount: 430 },
    { category: "Books", amount: 310 },
    { category: "Automotive", amount: 260 }
  ]


  const handleCategory = (name: string) => {
    // setSelectedCategory(name)
    navigate(`/marketPlaceStores/${name}`)
    // console.log(selectedCategory)
    setShowCategory(!showCategory)
  }

  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>

        <div className={styles.catgCont}>

          <div
            onClick={() => { setShowCategory(!showCategory) }}
            className={styles.catgBtn}
          >
            <MenuIcon2 />
            All Products
            <CaretIcon className={showCategory ? styles.caretIconUp : styles.caretIcon} color="black" />
            {/* <div className={styles.verticalStroke}></div> */}
          </div>

          {showCategory && (
            <div className={styles.productSelector}>
              {data.map((item, index) => (
                <div
                  className={styles.productItemsCont}
                  onClick={() => { handleCategory(item.category) }}
                >

                  <Typography
                    variant='heading6'
                    key={index}
                    className={styles.productItems}
                  >
                    {item.category} <span className={styles.amount}>{item.amount}</span>
                  </Typography>

                  {/* <hr className={styles.line} /> */}
                </div>
              ))}
            </div>
          )}

        </div>
        {/* <div className={styles.catgList}>
          {CategoryList.map((item) => (
            <ToggleButton key={item} name={item} isSelected={selectedButton === item} onClick={handleButtonClick} />
          ))}
        </div> */}
      </div>
    </div >
  );
};
